import React, { useEffect } from "react";
import Login from "../components/login/Login";
import { useLoader } from "../context/LoaderContext";

const LoginPage = () => {
  const { setLoading } = useLoader();

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [setLoading]);
  return (
    <>
      <Login />
    </>
  );
};

export default LoginPage;
